import { useOvenCookHistory, useOvens } from '@tovala/browser-apis-combinedapi'

export function useFirstOvenCookHistory({
  userID,
}: {
  userID: number | undefined
}) {
  const { data: ovens = [] } = useOvens({ userID })

  return useOvenCookHistory({
    ovenID: ovens[0]?.id,
    userID,
  })
}
